import React, { FC } from 'react';
import styled from 'styled-components';

import { Button } from './Common';

interface StyledRowButtonProps {
  bgColor: string;
  color: string;
  width?: number;
  minWidth?: number;
}

const StyledRowButton = styled(Button)<StyledRowButtonProps>`
  display: inline-block;
  background-color: ${(props) => props.bgColor};
  box-sizing: border-box;
  color: ${(props) => props.color};
  padding: 5px 10px;
  width: ${({ width }) => (width ? width : 'auto')};
  ${({ minWidth }) => (minWidth ? `min-width: ${minWidth}` : '')}
`;

interface RowButtonProps extends StyledRowButtonProps {
  onClick?: () => void;
}

export const RowButton: FC<RowButtonProps> = ({ children, ...props }) => (
  <StyledRowButton {...props}>{children}</StyledRowButton>
);
